export default "__VITE_ASSET__Cubjscqu__"